export default {
  init() {
    // JavaScript to be fired on the home page

    $('.home-slider').slick({
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2500,
      fade: true,
      lazyLoad: 'ondemand',
      arrows: false,
      dots: false,
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js